<template>
  <div>

    <div v-if="isMobile" class="d-flex align-items-center px-3 py-2 bg-light shadow-sm sticky-top">
      <b-button variant="link" class="p-0 mr-2" @click="drawerOpen = true">
        <b-icon-list></b-icon-list>
      </b-button>
      <span class="font-weight-bold">{{ activeTabTitle }}</span>
    </div>

    <b-sidebar
      id="product-reports-drawer"
      title="Product Reports Menu"
      bg-variant="light"
      text-variant="dark"
      shadow
      backdrop
      placement="left"
      :visible="drawerOpen"
      @hidden="drawerOpen = false"
    >
      <hr/>
      <ul class="list-unstyled m-0">
        <li v-for="(tab, index) in filteredTabs" :key="index" class="mb-2">
          <b-button
            block
            squared
            :variant="activeTabIndex === index ? null : 'link'"
            class="text-left"
            @click="selectTab(index)"
          >
            <b-icon :icon="tab.icon" class="mr-2"></b-icon>
            {{ tab.title }}
          </b-button>
        </li>
      </ul>
    </b-sidebar>

    <div v-if="!isMobile">
      <b-tabs card lazy v-model="activeTabIndex">
        <b-tab
          v-for="(tab, index) in filteredTabs"
          :key="index"
          :title="tab.title"
        >
          <keep-alive>
            <component 
              :is="tab.component" 
              :userDetails="userDetails"
            ></component>
          </keep-alive>
        </b-tab>
      </b-tabs>
    </div>

    <div v-if="isMobile" class="mt-2">
      <keep-alive>
        <component 
          v-if="activeTabComponent" 
          :is="activeTabComponent"
          :userDetails="userDetails"
        ></component>
      </keep-alive>
    </div>

  </div>
</template>

<script>
import {
  BIconList,
  BIconBarChart
} from "bootstrap-vue";

// Import the single tab component
import ProductReportsDashboard from './ProductReportsDashboard.vue';
import ProductStatsPage from './ProductStatsPage.vue';

export default {
  name: "ProductReportsMain",

  components: {
    ProductReportsDashboard,
    ProductStatsPage,
    BIconList,
    BIconBarChart
  },

  data() {
    return {
      drawerOpen: false,
      activeTabIndex: 0,
      isMobile: false,

      packet: { userDetails: {} },
      userDetails: {},

      tabs: [
        {
          title: "PRODUCT REPORTS",
          icon: "bar-chart",
          roles: ["admin", "locationadmin", "salesperson", "officeuser", "officemanager", "accountuser"],
          component: "ProductReportsDashboard"
        },
         {
    title: "PRODUCT STATS",
    icon: "bar-chart-fill",
    roles: ["admin", "locationadmin", "officeuser", "officemanager", "accountuser"],
    component: "ProductStatsPage"
  }
      ]
    };
  },

  computed: {
    filteredTabs() {
      const role = this.packet.userDetails.userrole || "";
      return this.tabs.filter(tab => tab.roles.includes(role));
    },
    activeTabTitle() {
      const tab = this.filteredTabs[this.activeTabIndex];
      return tab ? tab.title : "Menu";
    },
    activeTabComponent() {
      const tab = this.filteredTabs[this.activeTabIndex];
      return tab ? tab.component : null;
    }
  },

  methods: {
    selectTab(index) {
      this.activeTabIndex = index;
      this.drawerOpen = false;
    },
    handleResize() {
      this.isMobile = window.innerWidth < 768;
    },
    initializeUser() {
      try {
        this.packet = JSON.parse(localStorage.packet || "{}");
        this.packet.userDetails = JSON.parse(localStorage.userDetails || "{}");
        // Set userDetails for the prop
        this.userDetails = this.packet.userDetails || {};
        
        console.log('UserDetails loaded:', this.userDetails);
      } catch (err) {
        console.error("User data parsing failed:", err);
        // Set default userDetails
        this.userDetails = {
          username: '',
          name: '',
          id: '',
          userrole: ''
        };
      }
    }
  },

  created() {
    this.initializeUser();
  },

  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  }
};
</script>

<style scoped>
@media (max-width: 767px) {
  .b-tabs {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ProductReports/ProductReportsMain.vue